import { useEffect } from 'react';
import { GoalLabels } from '@/constants/recommendation';
import { ProfileStepIds, Goal } from '@/models/recommendation';
import { RadioQuestion } from '@/packages/profile-quiz/components/questions/radio-question';
import { useProfileQuiz } from '@/packages/profile-quiz/context/profile-quiz';
import type { QuestionProps } from '@/packages/profile-quiz/context/profile-quiz/types';
import { ProfileFields } from '@/packages/profile-quiz/context/profile-quiz/types';

export const GoalStep = (_props: QuestionProps) => {
  const { answers, setQuizAnswer, setCurrentStepValid } = useProfileQuiz();

  useEffect(() => {
    setCurrentStepValid(answers.goal !== null);
  }, [answers.goal, setCurrentStepValid]);

  const handleSelectGoal = (goal: Goal) => {
    setQuizAnswer(ProfileFields.Goal, goal);
    setCurrentStepValid(true);
  };

  return (
    <RadioQuestion
      questionTitle="🎯 Qual é o seu objetivo de carreira?"
      questionId={ProfileStepIds.Goal}
      processedResponseText={
        'Direcionamento definido! Com esse objetivo em mente consigo personalizar melhor sua jornada aqui na Galena.'
      }
      handleSelectAnswer={(answer) => handleSelectGoal(answer as Goal)}
      currentValue={answers.goal}
      options={Object.values(Goal).map((goal) => ({
        label: GoalLabels[goal],
        value: goal,
      }))}
    />
  );
};
